export function isCapabilityDisabledError(err: unknown): boolean {
  if (!err || typeof err !== 'object' || !('status' in err)) {
    return false;
  }

  const httpErr = err as { status?: number; error?: { Error?: string; error?: string } };
  if (httpErr.status !== 409) {
    return false;
  }

  const code = httpErr.error?.Error ?? httpErr.error?.error;
  return code === 'capability_disabled';
}

export function isPermissionDeniedError(err: unknown): boolean {
  return (err as { status?: number })?.status === 403;
}
